import React from 'react';
const ActivitySmallBox = (props) => (
  <div className='p-6 pt-3 bg-white rounded shadow h-120'>
    <div className='text-xl not-italic font-medium uppercase text-summary-header '>{props.header}</div>
    <div className='flex mt-2'>
      {props.img}
      <div className='flex mt-2 ml-5'>
        <div className='text-3xl not-italic font-medium text-summary-header '>{props.value ? props.value : '0'}</div>
        <div className='mt-3 ml-3 text-base not-italic font-normal capitalize text-secondary '> {props.subtitle}</div>
      </div>
    </div>
  </div>
);

export default ActivitySmallBox;
